/* eslint-disable react-hooks/exhaustive-deps */
import { IState, IUser, NOTIFICATION_ADMIN_MODE, useMainStore } from "@/settings/zustand"
import Feed from "../core/Feed"
import Notification from "./Notification"
import { useUser } from "@/settings/zustand/user"
import { useEffect, useState } from "react"
import NotificationLayout from "./NotificationLayout"

/* Protopia Ecosystem component */
export interface IPENotificationFeedFormProps {
    offset: number
}
const PENotificationFeedForm = (props: IPENotificationFeedFormProps): JSX.Element => {
    const user:IUser = useUser()
    const [paging, setPaging] = useState<string>("")
    const [tact, setTact]  = useState<number>(Math.random())
    const notificationAdminMode = useMainStore((state: IState) => state.notificationAdminMode)
    
    useEffect(() => useMainStore.subscribe(
        (state: IState) => changePaging()
      ), [])
    useEffect( () => {
        changePaging()
    }, [ user, notificationAdminMode ] )

    const changePaging = () => {
        setPaging(
            user.roles.includes("SuperAdmin") && notificationAdminMode === NOTIFICATION_ADMIN_MODE.ALL
                ?
                ` order: "DESC" order_by_meta:"id" `
                :
                ` order: "DESC" order_by_meta:"id"  metas:[{key:"adressee", value: "${user.id}"}] `
        )
        setTact(Math.random())
    }

    return <div className={`p-0 d-flex flex-column w-100 container `}>  
            <Feed
                layoutComponent={NotificationLayout}
                component={ Notification }
                data_type={ "PENotification" }
                paging={paging}
                is_hide_pagi={false}
                offset={ props.offset || 0 } 
                class_name={` row`}
                params={{ 
                    col: 1,
                    seed: tact
                }} 
                containerClassName={ "small-container" }
            /> 
        </div>
}
export default PENotificationFeedForm